import {Message, Loading} from 'element-ui'
// 组件方法
const buttonMixin = {
  inject: ['reportVm'],
  methods: {
    async downDataTemplate (tableId, reportId, name) {
      await this.eventBus.$emit('report.tampleDownload', {tableId, name})
      await this.$axios({
        method: 'GET',
        url: `/report-api/report/definition/template?tableId=${tableId}&reportId=${reportId}`
      }).then(res => {
        if (res.data && res.data[0] && res.data[0].status === 'success') {
          let ossDownloadUrl = sessionStorage.getItem('ossDownloadUrl')
          window.open(`${ossDownloadUrl}${res.data[0].result.dir}`)
        }
        // let blob = new Blob([res.data], {type: 'application/vnd.ms-excel'})
        // if (!!window.ActiveXObject || 'ActiveXObject' in window) {
        //   //  ie
        //   window.navigator.msSaveOrOpenBlob(blob, name + '.xlsx')
        // } else {
        //   let url = window.URL.createObjectURL(blob)
        //   let vDom = document.createElement('a')
        //   vDom.style.display = 'none'
        //   vDom.href = url
        //   vDom.setAttribute('download', name + '.xlsx')
        //   document.body.appendChild(vDom)
        //   vDom.click()
        //   document.body.removeChild(vDom)
        //   window.URL.revokeObjectURL(url)
        // }
      }).catch(err => {
        console.log(err)
      })
    },
    downErrorDataTemplate () {
      window.open(this.page.errorDataUrl)
    },
    beforeUpload () {
      this.page.fileStatus = 'isUploading'
    },
    afterUpload () {
      this.page.fileProgress = 0
    },
    handleClearFiles () {
      if (this.$refs.uploadButton instanceof Array) {
        this.$refs.uploadButton[0].clearFiles()
      } else {
        this.$refs.uploadButton.clearFiles()
      }
    },
    // 上传文件
    async upDataTemplate (param) {
      let tableId = param.data.mainTableId
      await this.eventBus.$emit('report.beforeUpDataTemplate', {tableId, param})
      let file = param.file
      let fd = new FormData()
      fd.append('file', file)
      fd.append('type', 'USER')
      await this.$axios.post(`/shared-api/files/uploadFiles`, fd, {
        onUploadProgress: (progressEvent) => {
          if (progressEvent.lengthComputable) {
            this.page.fileProgress = Math.floor(progressEvent.loaded / progressEvent.total * 100)
          }
        }
      }).then((res) => {
        if (res.data && res.data[0].status === 'success') {
          this.page.fileStatus = 'uploadSuccess'
          this.page.fileName = res.data[0].result.file
          this.page.fileDir = res.data[0].result.dir
          // 报表导入功能，当导入失败后，重新选择文件上传后，需要出现 立即导入按钮
          if (!this.page.uploadResult.showButton) {
            this.page.uploadResult.showButton = true
          }
        } else {
          this.page.fileStatus = 'uploadFail'
        }
      }).catch(() => {
        this.page.fileStatus = 'uploadFail'
      })
    },
    // 导入文件
    async importDataTemplate () {
      this.page.importFileProgress = 0
      if (!this.page.fileDir) {
        return this.$message.error('请先上传文件！')
      }
      if (this.page.dialog.view === 'import-action') {
        // 逻辑流4期新增导入逻辑流功能
        await this.$axios.get(`/logic-api/actions/${this.page.dialog.targetId}`).then((res) => {
          let variables = res.data.variables.filter(it => it.elementType === 'InputParameter')
          let formData = {}
          formData[variables[0].name] = `'${sessionStorage.getItem('ossDownloadUrl')}${this.page.fileDir}'`
          this.$axios.post(`/logic-api/actions/${this.page.dialog.targetId}/run`, formData).then((res) => {
            console.info(res.data)
          }).catch(err => {
            console.info(err)
          })
          this.page.dialog.visible = false
          this.$message({
            message: '导入已执行，请等待导入完成后查看',
            type: 'success'
          })
        })
      } else {
        this.page.fileStatus = 'isImporting'
        let tableId = this.report.mainTableId
        let reportId = this.report.id
        let reportName = this.report.name
        let compareField = this.compareField
        let fd = new FormData()
        fd.append('compareField', compareField)
        fd.append('reportId', reportId)
        fd.append('reportName', reportName)
        fd.append('fileUrl', this.page.fileDir)
        await this.eventBus.$emit('report.beforeImport', {el: this, fd: fd})
        await this.$axios.post(`/report-api/report/definition/uploadData/${tableId}`, fd).then(res => {
          if (res.data) {
            this.clearTimer = 1
            // 定时器查询导入进度
            this.setImportTimer(res.data, reportName)
          }
        }).catch(() => {
          // 取消按钮loading状态
          this.page.fileStatus = 'dataUsedUp'
        })
      }
    },
    async doActionThen (btn, dataId, tableId, name, row) {
      let redcatApp = this.redcatApp ? this.redcatApp() : undefined
      switch (btn.type) {
        case 'look':
          this.doActionTargetType(btn, dataId, true, row)
          break
        case 'create':
          this.doActionTargetType(btn)
          break
        case 'update':
          this.doActionTargetType(btn, dataId, false, row)
          break
        // 66th 新建透传
        case 'transmission-create':
          this.doActionTargetType(btn, undefined, undefined, row)
          break
        case 'delete':
          try {
            await this.eventBus.$emit('report.beforeDelete', { button: btn, dataId, row })
          } catch (e) {
            return
          }
          this.deleteData(dataId, tableId, btn)
          break
        case 'custom-top':
          try {
            if (redcatApp && btn.customJsName) {
              redcatApp[btn.customJsName] && redcatApp[btn.customJsName](this.reportVm)
            }
          } catch (e) {
            throw new Error(e)
          }
          let customReportId = [
            '16A53C07-2BB1-8358-DBDA-CDF068B457EF', '16A582A2-AD21-7E64-846C-F3D67F2557DD', '16CE1134-55D0-0036-0D6F-7353BECE7741', '16A57594-2330-95E4-813B-115958AAC3BD',
            '16C1DE71-0870-03DB-81CF-D8D4162F2A96', '171056C1-9ED0-00A8-F05B-61811B0D6292'
          ]
          if (customReportId.includes(dataId)) {
            if (!row || Object.keys(row).length === 0) {
              this.$message('请选择要操作的数据行')
            }
          }
          break
        case 'custom-bottom':
          try {
            if (redcatApp && btn.customJsName) {
              redcatApp[btn.customJsName] && redcatApp[btn.customJsName](this.reportVm)
            }
          } catch (e) {
            throw new Error(e)
          }
          break
        case 'action':
        case 'logic':
          this.runLogic(btn, row)
          break
        default:
          throw new Error('未知的按钮类型')
      }
      this.eventBus.$emit('report.buttonClick', {button: btn, dataId, row})
    },
    doAction (btn, dataId, tableId, name, row) {
      if (this.batchData) {
        this.batchData.isBatch = false
      }
      // 如果满足禁用条件且有禁用说明，就弹出提示框并返回
      let disabledCondition
      if (btn.conditions) {
        if (['create', 'import', 'export', 'custom-top', 'filter-item-calculation', 'logic'].includes(btn.type)) {
          disabledCondition = btn.conditions.find(condition => condition.forbidden && condition.tipsEnable)
        } else {
          disabledCondition = btn.conditions.find(condition => row[condition.id] && condition.tipsEnable)
        }
      }
      if (disabledCondition) {
        this.$message.warning(disabledCondition.tip)
        return
      }
      if (btn.type !== 'export' && btn.type !== 'print-column' && btn.tipsEnable) {
        this.$confirm('', btn.tip, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          customClass: 'publishMessageBox',
          center: true
        }).then(() => {
          this.doActionThen(btn, dataId, tableId, name, row)
        })
      } else if (btn.type === 'export') {
        this.export(dataId, name, btn.id)
        this.eventBus.$emit('report.buttonClick', {button: btn, dataId})
      } else if (btn.type === 'print-column') {
        this.printTemplate(btn, row)
      } else if (btn.type === 'import') {
        this.importType = btn.importType
        this.openDialog('import', '导入', '530px', '')
      } else if (btn.type === 'import-action') {
        this.openDialog('import-action', '导入', '530px', btn.targetId)
      } else if (btn.type === 'online-contract') {
        this.contractSigning(btn, row)
      } else if (btn.type === 'filter-item-calculation') {
        //  53期0121:新增筛选项计算属性
        this.filterItemCalculation(btn)
      } else {
        this.doActionThen(btn, dataId, tableId, name, row)
      }
    },
    async doActionTargetType (btn, dataId, disabled, row) {
      if (btn.targetId) {
        switch (btn.type) {
          case 'look':
            this.$set(this.formRuntimeDialog, 'title', '查看')
            break
          case 'create':
            this.$set(this.formRuntimeDialog, 'title', '新建')
            break
          case 'update':
            this.$set(this.formRuntimeDialog, 'title', '编辑')
            break
          case 'transmission-create':
            this.$set(this.formRuntimeDialog, 'title', '新建')
            break
        }
        this.formRuntimeDialog.disabled = disabled
        this.formRuntimeDialog.dataId = dataId
        // 0791 支持报表引用主表单的表格时，修改按钮指向主表单的功能生效
        for (let key in row) {
          if (key === `foreignKey${btn.id}`) {
            this.formRuntimeDialog.dataId = row[key]
          }
        }
        switch (btn.targetType) {
          case 'form':
            await this.eventBus.$emit('report.beforeFormSHow', {button: btn})
            this.formRuntimeDialog.type = 'form'
            this.formRuntimeDialog.id = btn.targetId
            // 报表操作列是修改才需要透传字段,查看只需要对比字段即可
            const getCompareField = btn.compareField ? row[btn.compareField] : ''
            if (btn.type === 'update') {
              this.formRuntimeDialog.compareField = getCompareField
              this.formRuntimeDialog.passFieldList = (btn.passFieldList !== '' && btn.passFieldList !== null) ? JSON.parse(btn.passFieldList) : []
              this.formRuntimeDialog.passFieldList.forEach(item => {
                if (item.form && item.report) {
                  item.value = item.report !== '默认值' ? row[item.report] : item.reportdefaultValue
                }
              })
            } else if (btn.type === 'look') {
              this.formRuntimeDialog.compareField = getCompareField
            } else if (btn.type === 'transmission-create') {
              this.formRuntimeDialog.openType = 'transmission-create'
              this.formRuntimeDialog.passFieldList = (btn.passFieldList !== '' && btn.passFieldList !== null) ? JSON.parse(btn.passFieldList) : []
              this.formRuntimeDialog.passFieldList.forEach(item => {
                if (item.form && item.report) {
                  item.value = item.report !== '默认值' ? row[item.report] : item.reportdefaultValue
                }
              })
            }
            this.$axios.get('/form-api/defines/' + this.formRuntimeDialog.id)
              .then(res => {
                this.formRuntimeDialog.width = JSON.parse(res.data.form.form.properties).formScreen
                this.formRuntimeDialog.visible = true
                if (btn.type === 'transmission-create') {
                  this.formRuntimeDialog.formValidates = res.data.form.form.formValidates && res.data.form.form.formValidates.filter(n => n.operationType.includes('create') && n.enable)
                  this.formRuntimeDialog.interactions = res.data.form.form.interactions ? res.data.form.form.interactions.filter(n => n.type.includes('create')) : []
                } else {
                  this.formRuntimeDialog.formValidates = res.data.form.form.formValidates && res.data.form.form.formValidates.filter(n => n.operationType.includes(btn.type) && n.enable)
                  this.formRuntimeDialog.interactions = res.data.form.form.interactions ? res.data.form.form.interactions.filter(n => n.type.includes(btn.type)) : []
                }
              })
            break
          case 'flow':
            this.formRuntimeDialog.type = 'process'
            this.formRuntimeDialog.id = btn.targetId
            this.$axios.get(`/process-api/runtime/loadProcessForm`, {params: {definitionId: btn.targetId}}).then((res) => {
              this.formRuntimeDialog.width = JSON.parse(res.data.component.properties).formScreen || 'full'
              this.formRuntimeDialog.visible = true
            })
            break
          default:
            throw new Error('未知的按钮类型')
        }
      } else {
        Message.warning('当前按钮未设置任何指向, 请联系管理设置')
      }
    },
    doColumnAction (dataId, row) {
      switch (this.report.clickColumn.type) {
        case 'look':
          this.$set(this.formRuntimeDialog, 'title', '查看')
          break

        case 'update':
          this.$set(this.formRuntimeDialog, 'title', '编辑')
          break
      }
      this.formRuntimeDialog.disabled = this.report.clickColumn.type === 'look'
      this.formRuntimeDialog.dataId = dataId
      // 0791 支持报表引用主表单的表格时，修改按钮指向主表单的功能生效
      for (let key in row) {
        if (key === `foreignKey${this.report.clickColumn.appointColumn}`) {
          this.formRuntimeDialog.dataId = row[key]
        }
      }
      this.formRuntimeDialog.type = 'form'
      this.formRuntimeDialog.id = this.report.clickColumn.appointForm
      this.$axios.get('/form-api/defines/' + this.formRuntimeDialog.id)
        .then(res => {
          this.formRuntimeDialog.width = JSON.parse(res.data.form.form.properties).formScreen
          this.formRuntimeDialog.visible = true
          this.formRuntimeDialog.formValidates = res.data.form.form.formValidates && res.data.form.form.formValidates.filter(n => n.operationType.includes(this.report.clickColumn.type) && n.enable)
          this.formRuntimeDialog.interactions = res.data.form.form.interactions ? res.data.form.form.interactions.filter(n => n.type.includes(this.report.clickColumn.type)) : []
        })
    },
    async  deleteData (dataId, tableId, btn) {
      if (tableId) {
        // 删除的时候表单通知
        if (btn.targetType === 'form' && btn.targetId) {
          await this.$axios.get(`/form-api/formNotice/sendNotice/${btn.targetId}/${dataId}`)
        }
        this.$axios.delete(`/report-api/report/data/${tableId}/${dataId}`)
        this.$emit('search')
      }
    },
    async export (reportId, name, buttonId) {
      let that = this
      await this.eventBus.$emit('report.beforeExport', {reportId, that, buttonId})
      this.exportLoading = Loading.service({
        lock: false,
        text: '正在导出, 请稍等',
        customClass: 'loading',
        spinner: '',
        background: 'rgba(0, 0, 0, 0.4)'
      })
      // 导出报表数据
      await this.$axios({
        method: 'post',
        url: `/report-api/report/data/export/${reportId}/${buttonId}`,
        data: this.param,
        disableInterceptors: true
      }).then(res => {
        if (res.data) {
          let timer = setInterval(() => {
            this.$axios.get('/report-api/report/data/getExportData', {params: {exportId: res.data}}
            ).then(res => {
              if (res.data && res.data.data.status === '1') {
                let ossDownloadUrl = sessionStorage.getItem('ossDownloadUrl')
                clearInterval(timer)
                window.open(`${ossDownloadUrl}${JSON.parse(res.data.data.resultJson.replace(/'/g, '"')
                )[0].result.dir}`)
                this.exportLoading.close()
                this.eventBus.$emit('report.afterExport', {reportId})
              } else if (res.data && res.data.status === '2') {
                this.exportLoading.close()
                this.openDialog('导出失败')
                clearInterval(timer)
                setTimeout(() => {
                  this.page.dialog.visible = false
                }, 3000)
              }
            })
          }, 1000)
        }
      })
        // let blob = new Blob([res.data], {type: 'application/vnd.ms-excel'})
        // if (!!window.ActiveXObject || 'ActiveXObject' in window) {
        //   //  ie
        //   window.navigator.msSaveOrOpenBlob(blob, name + '.xlsx')
        // } else {
        //   let url = window.URL.createObjectURL(blob)
        //   let vDom = document.createElement('a')
        //   vDom.style.display = 'none'
        //   vDom.href = url
        //   vDom.setAttribute('download', name + '.xlsx')
        //   document.body.appendChild(vDom)
        //   vDom.click()
        //   document.body.removeChild(vDom)
        //   window.URL.revokeObjectURL(url)
        // }
        .catch(() => {
          this.exportLoading.close()
          this.openDialog('exportError', '提示', '366px', '')
          setTimeout(() => {
            this.page.dialog.visible = false
          }, 3000)
        })
      throw new Error('中断操作')
    },
    // 打印
    printTemplate (btn, row) {
      let params = {
        templateId: btn.targetId,
        params: row,
        type: 'report',
        definitionId: this.report.id
      }
      this.$axios.post('/system-api/printTemplate/printTemplate', params).then(res => {
        window.open(`${sessionStorage.getItem('ossDownloadUrl')}${res.data.result.dir}`)
      })
    },
    // 发起电子合同签署
    contractSigning (btn, row) {
      let nameColumn = JSON.parse(btn.setting).nameColumn
      const loading = this.$loading({
        target: this.$parent.$el,
        lock: true,
        text: `正在向${row[nameColumn]}发起签署...`,
        background: 'rgba(0,0,0,.5)',
        customClass: 'contract-signing-model'
      })
      let data = {
        params: row,
        setting: JSON.parse(btn.setting)
      }
      this.$axios.post('/system-api/contract/report/sign', data).then(res => {
        if (res.status === 200) {
          loading.text = `向${row[nameColumn]}发起签署成功，等待对方签署即可`
          setTimeout(() => {
            loading.close()
          }, 500)
        }
      }).catch(() => {
        loading.close()
      })
    },
    //  53期0121:筛选项计算
    filterItemCalculation (btn) {
      let filterItemList = btn.filterItems && typeof btn.filterItems === 'string' ? JSON.parse(btn.filterItems) : {}
      let keys = Object.keys(filterItemList)
      let arr = []
      if (keys.length) {
        for (let i of keys) {
          let p = new Promise((resolve, reject) => {
            this.$axios.post('/form-api/runtime/calc', {'formula': filterItemList[i], 'variables': {}})
              .then(res => {
                let obj = Object.create(null)
                obj[`${i}`] = res.data
                resolve(obj)
              }).catch((err) => reject(err))
          })
          arr.push(p)
        }
        Promise.all(arr).then((values) => {
          let result = values.reduce((current, next) => Object.assign(current, next), Object.create(null))
          if (!this.param.filters) {
            this.param.filters = {}
          }
          for (let key in this.param.filters) {
            this.param.filters[key] = result[key] || ''
            this.$refs.filter.conditionValue[key] = result[key] || ''
          }
          // for (let key in this.$refs.filter.conditionValue) {
          //   this.$refs.filter.conditionValue[key] = result[key] || ''
          // }
          this.search()
        })
      } else {
        this.$message('请先设置筛选项计算条件')
      }
    },
    // 获取当前导入进度
    setImportTimer (uuid, reportName) {
      let timer = setInterval(() => {
        if (this.clearTimer === 1) {
          this.clearTimer = 2
          if (this.page.importFileProgress === 100) {
            clearInterval(timer)
            this.clearTimer = 2
            if (this.page.isimportSuccess === '1') {
              // 导入数据量过多，太快的调用search方法导入的sql还未执行完，故加个1000ms的延迟
              // 超出5000条的数据提示用户手动刷新
              setTimeout(() => {
                this.page.fileStatus = 'importSuccess'
                this.page.uploadResult.showButton = false
                this.page.dialog.visible = false
                if (Number(this.page.uploadResult.totalCount) > 5000) {
                  this.$message.warning('导入数据量较大，稍候请手动刷新页面')
                } else {
                  this.search()
                }
              }, 1000)
            } else {
              // 获取错误信息
              this.$axios.get(`/report-api/report/definition/uploadData/errorData/${uuid}?reportName=${reportName}`).then(res => {
                let ossDownloadUrl = sessionStorage.getItem('ossDownloadUrl')
                this.page.errorDataUrl = `${ossDownloadUrl}${res.data.data.jsonArray[0].result.dir}`
                this.page.uploadResult.successDataCount = res.data.data.importRecord.successDataCount
                this.page.uploadResult.errorDataCount = res.data.data.importRecord.errorDataCount
                this.page.uploadResult.showButton = false
                this.page.fileStatus = 'importFail'
              }).catch(() => {
                // 文件数据不对不会报错,非本报表的表格导入等其他问题才会报错,导入状态不置为失败
                this.page.fileStatus = 'afterImport'
                this.page.uploadResult.showButton = false
              }).finally(() => {
                this.search()
              })
            }
          } else {
            this.$axios.get(`/report-api/report/definition/getPercent?percentId=${uuid}`).then(res => {
              this.clearTimer = 1
              const importFileProgress = (Number(res.data.data.successDataCount) + Number(res.data.data.errorDataCount)) / Number(res.data.data.totalCount) * 100
              this.page.importFileProgress = isNaN(importFileProgress) ? 0 : importFileProgress
              this.page.uploadResult.totalCount = res.data.data.totalCount
              this.page.isimportSuccess = res.data.data.isSuccess
            }).catch(() => {
            // 取消按钮loading状态
              this.page.fileStatus = 'importfailed'
              this.clearTimer = 2
              clearInterval(timer)
            })
          }
        } else if (this.clearTimer === 3) {
          clearInterval(timer)
        }
      }, 1000)
    },
    // 运行逻辑流
    runLogic (btn, row) {
      let formData = {}
      let tip
      if (btn.type === 'action') {
        if (typeof btn.targetParameters === 'string') {
          btn.targetParameters = JSON.parse(btn.targetParameters)
        }
        for (let key in btn.targetParameters) {
          formData[key] = `'${row[btn.targetParameters[key]]}'`
        }
      }
      this.$axios.post(`/logic-api/actions/${btn.targetId}/run`, formData).then((res) => {
        console.info(res.data)
        if (!res.data.Message) {
          tip = '执行成功'
        } else {
          tip = res.data.Message.toString().substring(0, 100)
        }
        if (btn.type === 'logic') {
          tip = '操作已执行，请等待执行结束后查看数据'
        }
        this.$message({
          message: tip,
          type: 'success'
        })
        this.$emit('search')
      })
    }
  }
}

export {buttonMixin}



// WEBPACK FOOTER //
// ./src/components/report/runtime/button.js